import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysDefault$iterator$1Class;
function HashMapKeysDefault$iterator$1() {
  if (HashMapKeysDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.ca_1 = $entryIterator;
      }
      q1() {
        return this.ca_1.q1();
      }
      r1() {
        return this.ca_1.r1().m3();
      }
      p6() {
        return this.ca_1.p6();
      }
    }
    initMetadataForClass($);
    HashMapKeysDefault$iterator$1Class = $;
  }
  return HashMapKeysDefault$iterator$1Class;
}
var HashMapKeysDefaultClass;
function HashMapKeysDefault() {
  if (HashMapKeysDefaultClass === VOID) {
    class $ extends AbstractMutableSet() {
      static w7(backingMap) {
        var $this = this.b8();
        $this.v7_1 = backingMap;
        return $this;
      }
      da(element) {
        throw UnsupportedOperationException().a1('Add is not supported on keys');
      }
      i2(element) {
        return this.da(element);
      }
      a5() {
        return this.v7_1.a5();
      }
      i9(element) {
        return this.v7_1.s4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.i9(element);
      }
      p1() {
        var entryIterator = this.v7_1.l3().p1();
        return new (HashMapKeysDefault$iterator$1())(entryIterator);
      }
      q2() {
        return this.v7_1.q2();
      }
      o6() {
        return this.v7_1.o6();
      }
    }
    initMetadataForClass($, 'HashMapKeysDefault');
    HashMapKeysDefaultClass = $;
  }
  return HashMapKeysDefaultClass;
}
var HashMapValuesDefault$iterator$1Class;
function HashMapValuesDefault$iterator$1() {
  if (HashMapValuesDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.ea_1 = $entryIterator;
      }
      q1() {
        return this.ea_1.q1();
      }
      r1() {
        return this.ea_1.r1().n3();
      }
      p6() {
        return this.ea_1.p6();
      }
    }
    initMetadataForClass($);
    HashMapValuesDefault$iterator$1Class = $;
  }
  return HashMapValuesDefault$iterator$1Class;
}
var HashMapValuesDefaultClass;
function HashMapValuesDefault() {
  if (HashMapValuesDefaultClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static z7(backingMap) {
        var $this = this.m6();
        $this.y7_1 = backingMap;
        return $this;
      }
      s9(element) {
        throw UnsupportedOperationException().a1('Add is not supported on values');
      }
      i2(element) {
        return this.s9(element);
      }
      r9(element) {
        return this.y7_1.t4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.r9(element);
      }
      p1() {
        var entryIterator = this.y7_1.l3().p1();
        return new (HashMapValuesDefault$iterator$1())(entryIterator);
      }
      q2() {
        return this.y7_1.q2();
      }
      o6() {
        return this.y7_1.o6();
      }
    }
    initMetadataForClass($, 'HashMapValuesDefault');
    HashMapValuesDefaultClass = $;
  }
  return HashMapValuesDefaultClass;
}
//region block: exports
export {
  HashMapKeysDefault as HashMapKeysDefaultd8xopyn6vbgh,
  HashMapValuesDefault as HashMapValuesDefault3j1xghpfb6bpq,
};
//endregion

//# sourceMappingURL=HashMapEntryDefault.mjs.map
